export type loan_credit_getCreditInfo_response = {
  totalLimit: number,
  availableQuota: number,
  quotaTotalLimit: number,
  usedQuotaLimit: number,
  creditQuotaStatus: number,
  creditTime: string,
  threeFactorAuth: number
}

export type loan_credit_ocrIdCard_request = {
  idCardOssKey?: string,
  imageBase64?: string,
  cardSide: string

}
export type loan_credit_ocrIdCard_response = {
  realName: string,
  idCard: string,
  gender: number,
  nation: string,
  idCardAddress: string,
  visaAuthority: string,
  validPeriod: string,
  warningMessage: string
}

// 验证用户实名认证
export type loan_credit_verificationThreeFactorAuthCode_request = {
  verificationCode: string
}
export type loan_credit_verificationThreeFactorAuthCode_response = {

}

/**
 * 联系人相关信息
 *
 * ContactInfo
 */
export interface ContactInfo {
    firstName: string; // 第一联系人姓名
    firstPhone: string; // 第一联系人电话
    firstRelation: number; // 第一联系人关系
    secondName: string; // 第二联系人姓名
    secondPhone: string; // 第二联系人电话
    secondRelation: number; // 第二联系人关系
    [property: string]: any;
}

/**
 * 设备信息
 *
 * DeviceInfo
 */
export interface DeviceInfo {
    deviceId?: string; // 设备唯一标识
    ip?: string; // 用户IP  
    isVirtual?: number; // 设备是否虚拟机
    phoneMarker?: string; // 手机制造商
    phoneModel?: string; // 手机型号
    systemVersion?: string; // 设备系统版本号
    wlanType?: number;
    [property: string]: any;
}

/**
 * 用户基础信息
 *
 * UserBaseInfo
 */
export interface UserBaseInfo {
    residentialAddress: string; // 居住地址
    areaCode: string; // 居住区Code
    areaName: string; // 居住区
    cityCode: string; // 居住城市Code
    cityName: string; // 居住城市
    companyAddress?: string; // 公司详细地址
    companyArea?: string; // 公司所在区
    companyCity?: string; // 公司所在城市
    companyName?: string; // 公司名称
    companyProvince?: string; // 公司所在省份
    education?: number; // 学历
    maritalStatus?: number; // 婚姻状态
    provinceCode: string; // 居住省份Code
    provinceName: string;
    [property: string]: any;
}

/**
 * 用户扩展信息
 *
 * UserExtraInfo
 */
export interface UserExtraInfo {
    bankCard?: string; // 银行卡
    companyNature?: number; // 公司性质
    companyTelephone?: string; // 公司电话
    degree?: number; // 学位
    houseInfo?: number; // 住房情况
    income?: number; // 月收入
    incomeSource?: number; // 收入来源
    industry?: number; // 行业
    liabilities?: number; // 负债情况
    loanUse?: number; // 借款用途
    occupation?: number; // 职业性质
    position?: number; // 职位
    reservePhone?: string; // 预留手机号
    sesameScore?: number; // 芝麻分
    workYears?: number; // 工作年限
    [property: string]: any;
}

export interface userInfo_save_request {
  contactInfo?: ContactInfo; // 联系人相关信息
  deviceInfo?: DeviceInfo; // 设备信息
  userBaseInfo?: UserBaseInfo; // 用户基础信息
  userExtraInfo?: UserExtraInfo;
  [property: string]: any;
}

export interface userInfo_detail_response {
  annualIncome?: number; // 0-20万以上, 1-10-20万, 2-5-10万, 3-5万以下
  areaCode?: string; // 居住区Code
  areaName?: string; // 居住区
  cityCode?: string; // 居住城市Code
  cityName?: string; // 居住城市
  companyAddress?: string; // 公司详细地址
  companyName?: string; // 公司名称
  companyNature?: number; // 公司性质
  companyRegion?: string; // 公司所在地区
  companyTelephone?: string;
  contacts?: ContactInfo[];
  degree?: number; // 学位
  education?: number; // 学历，0-博士后, 1-博士, 2-硕士, 3-本科, 4-高中, 5-中专及以下
  gender?: number; // 性别，1-男、2-女
  houseInfo?: number; // 住房情况
  income?: number; // 月收入
  incomeSource?: number; // 收入来源
  industry?: number; // 行业
  industryName?: string; // 行业名称
  liabilities?: number; // 负债情况
  loanUse?: number; // 借款用途
  maritalStatus?: number; // 婚姻状态，0-已婚, 1-未婚, 2-丧偶, 3-离异, 4-再婚,5-未知
  mobile?: string; // 手机号码
  nation?: string; // 民族
  occupation?: number; // 职业性质  
  occupationName?: string; // 职业名称
  position?: number; // 职位
  provinceCode?: string; // 居住省份Code
  provinceName?: string; // 居住省份
  realName?: string; // 真实姓名
  residentialAddress?: string; // 住宅详细地址
  residentialRegion?: string; // 住宅地区
  sesameScore?: number; // 芝麻分
  submitStatus?: number; // 用户信息提交状态：0-临时保存，1-提交完成
  submitTime?: string; // 用户信息提交时间
  uid?: number; // uid
  workYears?: number; // 工作年限
  [property: string]: any;
}

export interface BankCardVO {
  bankCard?: string; // 银行卡
  bankCode?: string; // 银行编号
  bankName?: string; // 银行名称
  bindStatus?: number; // 绑卡状态，0-未绑定、1-绑定中、2-绑定成功、3-绑定失败
  cardType?: number; // 银行卡类型，1-还款；2-放款
  fourFactorAuth?: number; // 银行四要素认证，0-未通过、1-已通过
  id?: number | string; // id
  reservePhone?: string; // 预留手机号
  hasBindExternalType: boolean; // 是否已绑定 当前开启的代扣渠道
  [property: string]: any;
}

export type userInfo_bankCard_list_response = BankCardVO[]


export interface userInfo_bankCard_add_request {
  bankCard: string; // 银行卡号
  bankName: string; // 银行名称
  reservePhone: string; // 预留手机号
  bankCode?: string; // 银行编号
  verificationCode?: string; // 验证码
  [property: string]: any;
}

export interface userInfo_bankCard_del_id_request {
  id: string; // 银行卡id
}

export interface userInfo_bankCard_bind_verificationCode_id_request {
  id: string; // 银行卡id
}

export interface userInfo_bankCard_bind_request {
  id: string; // 银行卡id
  verificationCode: string; // 验证码
}

export interface userInfo_bankCard_unbind_id_request {
  id: string; // 银行卡id
}

export interface userInfo_getRepaymentAccount_response {
    repaymentCompanyName?: string; // 还款账户主体名称
    repaymentCreditCode?: string; // 还款账户社会信用代码
}

export interface loan_order_trialCalculation_request {
  orderNo: string; // 订单号
}

export interface LoanBillDTO {
  id: string; // 账单id
  billAmount?: number; // 账单金额=账单本金+账单利息
  billDate?: string; // 账单日期
  billFeeAmount?: number; // 账单费用
  billInterestAmount?: number; // 还款利息
  billPenaltyAmount?: number; // 账单罚息
  billPrincipalAmount?: number; // 账单本金
  billShowBeginDate?: string; // 账单开始显示时间
  billStatus?: number; // 账单状态：1：正常、2：逾期、3：还款
  billType?: number; // 账单类型：1-信贷，2-赊销
  currTerm?: number; // 当前期数
  repaidAmount?: number; // 账单已还金额
  repaymentDate?: string; // 还款日期
  repaymentStatus?: number;
  [property: string]: any;
 }

export interface loan_order_trialCalculation_response {
  applyStatus?: number; // 申请单状态：0-发起申请，1-已确认试算，2-申请不通过
  firstRepaymentDate?: string; // 首期还款日期
  id?: number; // 赊销申请id
  loanBillList?: LoanBillDTO[]; // 试算还款计划列表
  loanPeriodNum?: number; // 申请期数
  mallTotalAmount?: number; // 商城订单金额
  trialType?: number; // 试算类型：1-先享后付(赊销)
  [property: string]: any;
}

export interface loan_order_trialConfirm_request {
  orderNo: string; // 订单号
}

export interface loan_order_trialConfirm_response {
  applyStatus?: number; // 申请单状态：0-发起申请，1-已确认试算，2-申请不通过
  firstBillAmount?: number; // 首期账单金额
  firstRepaymentDate?: string; // 首期还款日期
  id?: number; // 赊销申请id
  loanBillList?: LoanBillDTO[]; // 试算还款计划列表
  loanPeriodNum?: number; // 申请期数
  mallTotalAmount?: number; // 商城订单金额
  trialType?: number; // 试算类型：1-先享后付(赊销)
}

export interface loan_order_confirm_sign_request {
  orderNo: string; // 订单号
  redirectUrl?: string; // 重定向url
}

export type loan_order_confirm_sign_response = string // 人脸识别链接

export interface loan_order_loanOrder_request {
  orderNo: string; // 订单号
}

export interface loan_repayment_repaymentSystemConfig_response {
  enableCreditSalesRepayment: boolean; // 是否启用赊销还款
  repaymentMethodList: number[]; // 还款方式枚举：还款方式：1-系统代扣，2-用户对公打款，3-用户线下还款,4-用户线上还款，5-运营代扣,6-银行卡扣款,7-二维码收款
}

export interface loan_repayment_lastRepaymentDetail_response {
  repaymentNo?: string; // 还款编号
  totalAmount?: number; // 支付金额
  payUrl?: string; // 支付连接
  timeExpireTime?: string; // 支付失效时间
  repaymentMethod?: number; // 还款方式：1-系统代扣，2-用户对公打款，3-用户线下还款,4-用户线上还款，5-运营代扣,6-银行卡扣款,7-二维码收款
}
export interface loan_order_loanOrder_response {
    contractList?: LoanContractDTO[]; // 合同列表
    firstBillAmount?: number; // 首期账单金额
    firstRepaymentDate?: string; // 首期还款日期
    id?: number; // 主键
    loanBillList?: LoanBillDTO[]; // 还款计划列表
    loanContractList?: LoanContractVO[]; // 合同列表
    loanPeriodNum?: number; // 申请期数
    mallTotalAmount?: number; // 商城订单金额
    orderNo?: string; // 商城订单号
    orderStatus?: number; // 订单状态：1-待支付首款、 2-待签署合同、3-待赋强公证、4-放款中，5-放款成功、6-放款失败、7-已退货退款
    orderType?: number; // 订单类型：1-信贷分期，2-赊销分期
    paymentBankCard?: BankCardVO; // 收款账户
    repaymentAccount?: RepaymentAccountVO; // 还款账户主体信息
    repaymentBankCard?: BankCardVO; // 还款账户
    [property: string]: any;
}


export interface LoanContractDTO {
  contractInitKey?: string; // 创建合同文件ossKey
  contractName?: string; // 合同名称
  contractOssKey?: string; // 签署成功,合同文件ossKey
  id?: number; // 主键
  serviceProviderCode?: loan_contract_method
}

export interface LoanContractVO {
  contractInitKey?: string; // 创建合同文件ossKey
  contractOssKey?: string; // 签署成功,合同文件ossKey
  contractName?: string; // 合同名称
  contractUrl?: string; // 合同url
  fileId?: number;
  serviceProviderCode?: loan_contract_method // 服务提供方
}

export interface BankCardVO {
  bankCard?: string; // 银行卡
  bankCode?: string; // 银行编号
  bankName?: string; // 银行名称
  id?: number | string; // id
}

export interface RepaymentAccountVO {
  repaymentCompanyName?: string; // 还款账户主体名称
  repaymentCreditCode?: string; // 还款账户社会信用代码
}

export interface loan_order_contract_create_request {
  orderNo: string; // 订单号
  repaymentCardNoId: string; // 还款银行卡id
}


export interface ContractCreateVO {
  contractUrl?: string; // 文件下载链接
  fileId?: string; // 文件id
  fileName?: string; // 文件名
}
export type loan_order_contract_create_response = ContractCreateVO[]

// 合同模板类型，
// 1-商品购买服务协议
// 2-扣款授权协议
// 3-个人信息查询及使用综合授权书
// 4-人脸识别验证授权书
// 5-电子签章授权书
export type loan_order_contract_listContractTemp_contractType_request = number[]

export interface ContractTempVO {
  contractTemplateName?: string; // 合同模板名称
  contractTemplateUrl?: string; // 合同模板URL
}

export type loan_order_contract_listContractTemp_contractType_response = ContractTempVO[]




export interface loan_repayment_loanBillTrial_billId_request {
  billId: string; // 账单id
}

export interface loan_repayment_loanBillTrial_billId_response {
  billFeeAmount?: number; // 账单费用
  billInterestAmount?: number; // 还款利息
  billPenaltyAmount?: number; // 账单罚息
  billPrincipalAmount?: number; // 账单本金
  billStatus?: number; // 账单状态：0:未生效、1：正常、2：逾期、3：还款,4-部分还款
  billType?: number; // 账单类型：1-信贷，2-赊销
  currTerm?: number; // 当前期数
  remainderPrincipalAmount?: number; // 剩余应还本金
  repaymentStatus?: number; // 账单还款状态：1：发起，2-还款中，3-还款成功，4-还款失败
  loanOrderNo?: string; // 赊销订单编号
  [property: string]: any;
}

export interface loan_repayment_loanOrderTrial_loanId_request {
  loanId: string; // 订单号
}

export interface loan_repayment_loanOrderTrial_loanId_response {
  billType?: number; // 账单类型：1-信贷，2-赊销
  orderNo?: string; // 赊销订单编号
  totalBillPenaltyAmount?: number; // 总账单罚息
  totalRemainderPrincipalAmount?: number; // 总剩余应还本金
  repaymentLimit?: boolean; // 是否可以还款
  [property: string]: any;
}

export interface loan_repayment_submit_billId_request {
  billId: string; // 账单id
  repaymentMethod?: number; // 还款方式
}

export interface loan_repayment_submit_billId_response {
  totalAmount?: number; // 支付金额
  payUrl?: string; // 支付连接
  timeExpireTime?: string; // 支付失效时间
  repaymentMethod?: number; // 还款方式
  repaymentNo?: string; // 还款编号
}

export interface loan_repayment_submit_settleFull_loanOrderNo_request {
  loanOrderNo: string; // 赊销订单编号
  repaymentMethod?: number; // 还款方式
}

export interface loan_repayment_submit_settleFull_loanOrderNo_response {
  [property: string]: any;
}

export interface loan_repayment_canBeRepaymentStatus_loanOrderNo_request {
  loanOrderNo: string; // 赊销订单编号
}

// 修改贷款订单还款银行卡
export interface loan_order_loanOrder_updateRepaymentCard_request {
  loanOrderNo?: string; // 赊销订单编号
  bankCardId?: number; // 银行卡id
}

// 根据还款id关闭还款记录
export interface loan_repayment_close_repayment_request {
  repaymentNo: string; // 还款编号
}
// 签约方式
export type loan_contract_method = 'fdd' | 'esign'

/** 展示环节枚举 */
export enum LinkShowEnum {
  /** 授信时展示 */
  CREDIT = 1,
  /** 借款前列表展示 */
  LOAN_LIST = 2,
  /** 借款前弹窗展示 */
  LOAN_POPUP = 3,
  /** 代扣绑卡时展示 */
  BINDCARD = 4,
}

/** 协议类型枚举 */
export enum ProtocolEnum {
  /** 购轻松授信协议 */
  GQS_CREDIT = 1,
  /** 合作方授信协议 */
  PARTNER_CREDIT = 2,
  /** 代扣协议 */
  WITHHOLD = 3,
  /** 借款协议 */
  LOAN = 4,
}

/** 获取放款现金贷协议 - 请求参数 */
export interface marketing_loan_disbursement_protoco_request {
  /**
   * 渠道码
   */
  channelCode?: string;
  /**
   * 资金方代码
   */
  funderCode: string;
  /**
   * 展示环节:1-授信时展示,2-借款前列表展示,3-借款前弹窗展示,4-代扣绑卡时展示
   */
  linkShow: LinkShowEnum;
  /**
   * 协议类型:1-购轻松授信协议,2-合作方授信协议,3-代扣协议,4-借款协议
   */
  protocolType: ProtocolEnum;
}

export interface marketing_loan_disbursement_protoco_item {
  /**
   * 协议类型 0-文本类型 1-url类型
   */
  agreementType?: number;
  /**
   * 协议内容
   */
  content?: string;
  /**
   * 协议名称
   */
  protocolName?: string;
  /**
   * 协议链接
   */
  url?: string;
}

/** 获取放款现金贷协议 - 响应参数 */
export type marketing_loan_disbursement_protoco_response = marketing_loan_disbursement_protoco_item[]

/** 获取授信人脸认证链接 - 请求参数 */
export interface loan_cash_faceVerify_request {
  /**
   * 资金方代码
   */
  funderCode: string;
  /**
   * 重定向跳转地址
   */
  redirectUrl?: string;
}

/** 获取用户授信状态 - 响应参数 */
export interface loan_cash_getCreditApplyStatus_response {
  /** 
   * uid
   */
  uid: number
  /** 
   * 授信申请编号
   */
  creditApplyNo:string
  /** 
   * 第三方授信系统流水编号
   */
  thirdPartyId: string
  /**
   * 授信申请状态 0-未授信、1-正常、3-授信不通过，4-授信拒绝
   */
  creditQuotaStatus: number;
  /** 
   * 人脸状态,0-未开始校验，1-发起，2-失败，3-人工审核中，4-成功
   */
  faceStatus: number
  /** 
   * 刷脸底图ossKey
   */
  faceVerifyOssKey: string
  /** 
   * 拒绝原因
   */
  cause:string
  /**
   * 授信额度，授信成功返具体额度
   */
  totalLimit?: number;
}

export interface application_loan_cash_faceVerify_request {
  /**
   * 订单编号
   */
  orderNo: string;
  /**
   * 重定向地址
   */
  redirectUrl: string;
}

// 检查是否有进行中的贷款订单 - 响应
export type loan_cash_hasLoaningOrder_response = boolean

// 获取现金贷款订单详情 - 请求
export interface loan_cash_detail_orderNo_request {
  orderNo: string; // 现金贷款订单编号
}

// 获取现金贷款订单详情 - 响应
export interface loan_cash_detail_orderNo_response {
      /**
     * 放款申请时间
     */
    applyTime?: string;
    /**
     * 授信申请编号
     */
    creditApplyNo?: string;
    /**
     * 还款日
     */
    dueDay?: number;
    /**
     * 还款日规则(1-放款日对日;2-固定日)
     */
    dueDayMethod?: number;
    /**
     * 首期还款日
     */
    firstRepayDay?: string;
    funderCode?: string;
    /**
     * 主键
     */
    id?: number;
    /**
     * 资方利率
     */
    interestRate?: number;
    /**
     * 贷款金额
     */
    loanAmount?: number;
    /**
     * 收款银行卡id
     */
    loanCardNoId?: number;
    /**
     * 贷款申请期数
     */
    loanPeriodNum?: number;
    /**
     * 用户手机号
     */
    mobile?: string;
    /**
     * 贷款订单编号
     */
    orderNo?: string;
    /**
     * 订单状态:0-已创建;1-待人脸认证;2-借款申请中;3-放款成功;4-放款失败;9-已取消
     */
    orderStatus?: number;
    /**
     * 还款方式(1-等额本金；2-等额本息)
     */
    repayMethod?: number;
    /**
     * 对客利率
     */
    totalRate?: number;
    /**
     * 用户唯一id
     */
    uid?: number;
    /**
     * 用户姓名
     */
  [property: string]: any;
}

// 借款试算 - 请求
export interface loan_cash_trialCalculation_request {
  loanAmount?: number; // 放款金额
}

// 借款试算 - 响应
export interface LoanCashTrialPlanDTO {
  /**
   * 本期还款金额
   */
  currentRepayAmount?: number;
  /**
   * 应还款日
   */
  dateDue?: string;
  /**
   * 本期应还利息
   */
  interest?: number;
  /**
   * 期数
   */
  period?: number;
  /**
   * 本期应还本金
   */
  repayPrincipal?: number;
}
export interface loan_cash_trialCalculation_response {
  /** 
   * 还款计划明细
  */
  details: LoanCashTrialPlanDTO[],
  /**
   * 总利息
   */
  totalInterest?: number;
  /**
   * 总本金
   */
  totalPrincipal?: number;
  /**
   * 总还款金额
   */
  totalRepayAmount?: number;
}

// 确认试算(提交借款) - 请求
export interface loan_cash_trialConfirm_request {
  loanAmount?: number; // 放款金额
  purpose?: string; // 借款用途
  loanCardNoId: string; // 收款银行卡ID
}

// 确认试算 - 响应
export type loan_cash_trialConfirm_response = string // 现金贷款订单id

// 发送绑卡短信验证码 - 请求
export interface userInfo_bankCard_sendBindCode_request {
  bankCardId: string;
  externalType?: number; // 代扣渠道类型
}

// 验证短信验证码并绑定银行卡 - 请求
export interface userInfo_bankCard_verifyBindCode_request {
  id: string; // 银行卡id
  verificationCode: string; // 验证码
  externalType?: number; // 第三方代扣类型
}

// 获取支持绑卡的银行卡列表 - 请求
export interface userInfo_bankCard_getSupportBankList_request {
  externalType?: number; // 代扣渠道类型
}

// 获取支持绑卡的银行卡列表 - 响应
export interface SupportBankListVO {
  bankCode: string; // 银行代码
  bankName: string; // 银行名称
  [property: string]: any;
}
export type userInfo_bankCard_getSupportBankList_response = SupportBankListVO[]

/** 获取二维码凭证信息 - 响应 */
export interface sso_getTicketInfo_response {
  /**
   * 资金方代码（产品类型）
   */
  funderCode: string;
  /**
   * 手机号
   */
  mobile: string;
  /**
   * 用户id
   */
  uid: number;
  /** 
   * 渠道码
   */
  channelCode:string
}

/** 身份证过期类型 */
export const enum IdCardExpiredType { 
  /** 
   * 未过期
   */
  NOT_EXPIRED = 0,
  /** 
   * 即将过期
   */
  ABOUT_TO_EXPIRE = 1,
  /** 
   * 已过期
   */
  EXPIRED = 2
}

